// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__lMB+p","empty":"Navbar_empty__KBPEf","box1":"Navbar_box1__TopMx","box2":"Navbar_box2__8qPrq"};